import { keyframes, styled } from "../../../seenspire-library";

const fadeAnimation = keyframes`
  from {opacity: 1;}
  to {opacity: 0.25;}
` 

export const SpinnerWrapper = styled.div`
    position: relative;
    width: 18px;
    height: 18px;
    display: inline-block;
    background: transparent;
    padding: 0px;

    div {
      width: 7%;
      height: 25%;
      background: #FFF;
      position: absolute;
      left: 49%;
      top: 37%;
      opacity: 0;
      border-radius: 50px;
      -webkit-border-radius: 50px;
      box-shadow: 0 0 3px rgba(0,0,0,0.2);
      -webkit-box-shadow: 0 0 3px rgba(0,0,0,0.2);
      animation: ${fadeAnimation} 1s linear infinite;
    }
`;

export const SpinnerBar1 = styled.div`
  transform:rotate(0deg) translate(0, -130%);
  animation-delay: 0s !important;
  -webkit-animation-delay: 0s !important;;
`;
export const SpinnerBar2 = styled.div`
  transform:rotate(45deg) translate(0, -130%);
  animation-delay: -0.9167s !important;;
  -webkit-animation-delay: -0.9167s !important;;
`;
export const SpinnerBar3 = styled.div`
  transform:rotate(90deg) translate(0, -130%);
  animation-delay: -0.797s !important;;
  -webkit-animation-delay: -0.797s !important;;
`;
export const SpinnerBar4 = styled.div`
  transform:rotate(135deg) translate(0, -130%);
  animation-delay: -0.6787s !important;;
  -webkit-animation-delay: -0.6787s !important;;
`;
export const SpinnerBar5 = styled.div`
  transform:rotate(180deg) translate(0, -130%);
  animation-delay: -0.559s !important;;
  -webkit-animation-delay: -0.559s !important;;
`;
export const SpinnerBar6 = styled.div`
  transform:rotate(225deg) translate(0, -130%);
  animation-delay: -0.4404s !important;;
  -webkit-animation-delay: -0.4404s !important;;
`;
export const SpinnerBar7 = styled.div`
  transform:rotate(270deg) translate(0, -130%);
  animation-delay: -0.3214s !important;;
  -webkit-animation-delay: -0.3214s !important;;
`;
export const SpinnerBar8 = styled.div`
  transform:rotate(315deg) translate(0, -130%);
  animation-delay: -0.2023s !important;;
  -webkit-animation-delay: -0.2023s !important;;
`;